import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AppState } from "./app.reducer";



export const selectAppState = createFeatureSelector<AppState>('app');
export const selectLanguage = createSelector(
  selectAppState,
  (state: AppState) => state.language
);
export const selectTheme = createSelector(
  selectAppState,
  (state: AppState) => state.theme
);
export const selectIsLoading = createSelector(
  selectAppState,
  (state: AppState) => state.isLoading
);
export const selectSelectableProjects = createSelector(
  selectAppState,
  (state: AppState) => state.selectableProjects
);
export const selectProjectById = (projectId: number) =>
  createSelector(selectAppState, (state: AppState) =>
    state.selectableProjects.find(p => p.id === projectId) || null
  );
export const selectErrorMessage = createSelector(
  selectAppState,
  (state: AppState) => state.errorMessage
);
export const selectCurrentProject = createSelector(
  selectAppState,
  (state: AppState) => state.currentProject
);
export const selectCurrentProjectId = createSelector(

  selectAppState,
  (state: AppState) => state.currentProjectId
);
export const selectCurrentUser = createSelector(
  selectAppState,
  (state: AppState) => state.currentUser
);
export const selectIsProjectSet = createSelector(
  selectAppState,
  (state: AppState) => state.currentProjectId !== null
);
export const selectBillingSummaryFilters = createSelector(
  selectAppState,
  (state: AppState) => state.billingSummaryFilters
);
